/**
 * Convert a string to a color using a simple FNV-1a hash with an avalanche
 * finalizer, so similar strings (e.g. sequential IDs) still get distinct colors
 * @param {string} str - The string to color-hash
 * @returns {string} The color in hex
 */
export const stringToColor = (str, { white = 0 } = {}) => {
    const s = (str || '').toString();

    // FNV-1a hash (seeded with golden-ratio constant instead of the standard offset basis)
    let h = 0x9e3779b9;
    for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }

    // Murmur-style finalizer for better bit avalanche
    h ^= h >>> 13;
    h = Math.imul(h, 0x5bd1e995);
    h ^= h >>> 15;

    const hash = h & 0xFFFFFF;

    // Convert hash to RGB
    const r = (hash >> 16) & 0xFF;
    const g = (hash >> 8) & 0xFF;
    const b = hash & 0xFF;

    const mix = (channel, white) => Math.round(channel * (1 - white) + 255 * white);

    // Mix with white according to 'white' param (white=1 -> all white, 0->original color)
    const mr = mix(r, white);
    const mg = mix(g, white);
    const mb = mix(b, white);

    // Convert back to hex
    const hex = (v) => v.toString(16).padStart(2, '0');
    return `#${hex(mr)}${hex(mg)}${hex(mb)}`;
};